/**
 * namesForeignScope reports whether a studio URL's `organization_id` names an organization the
 * reader holds no active membership in, which the studio then drops for the personal space.
 *
 * A link can name any organization (a colleague's, one the reader left, the shared root
 * organization), and the studio would otherwise open on a tree the API refuses to list and a
 * viewer that reads that scope's overlays. A member organization stays whatever its agreement:
 * one without Map Studio opens read-only, its folders readable, rather than being taken away.
 * An absent or non-string id names no scope, the personal space already.
 *
 * @param organizationId The `organization_id` the studio's search carries, as parsed.
 * @param organizationIds The organizations the reader is an active member of.
 * @returns Whether the scope is to be dropped.
 */
export const namesForeignScope = (
  organizationId: unknown,
  organizationIds: readonly string[],
): boolean =>
  typeof organizationId === "string" &&
  organizationId !== "" &&
  !organizationIds.includes(organizationId);
